import styled from "styled-components";
import {FC, useRef, useState} from "react";
import {ColorElement} from "../../pages/projectEdit/components/ColorPicker/styles";
import {ChangeBgBtn, UserColorChoose, UserColorChooseBlock} from "../../pages/projectEdit/styles";
import ClickAwayListener from "react-click-away-listener";
import SketchPicker from "react-color/lib/components/sketch/Sketch";
import {LayoutConst} from "../../../core";

const ColorPickerWrapper = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 12px;
    row-gap: 10px;
    width: fit-content !important;

    ${ColorElement} {
        margin: 0;
    }
    ${UserColorChoose} {
        margin: 0;
        height: 36px!important;
        width: 36px!important;

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 26px!important;
            width: 26px!important;
        }
    }

    ${ChangeBgBtn} {
        height: 36px!important;
        width: 36px!important;
        
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 26px!important;
            width: 26px!important;
        }
    }
    
    input {
        height: inherit !important;
        width: 100% !important;
        font-weight: inherit;
        font-size: 11px !important;
        line-height: inherit;
        color: inherit !important;
        background-color: inherit !important;
    }
`

interface ColorPickerProps {
    onChange?: (color: string) => void
    value: string,
}

const COLORS = [
    '#006FFF', '#C43C2C', '#F6C3A1', '#F5BF57', '#F3EC72', '#A3B51D', '#C1D3C4', '#B0C9E3', '#4E7CD4', '#000', '#ADA7A0', '#E1DDCD', '#D2D4D3',
];


export const ColorPickerVertical:FC<ColorPickerProps> = ({ value, onChange }) => {

    const colorPickerButton = useRef<HTMLDivElement>(null);
    const [picker, togglePicker] = useState(false);

    return <ColorPickerWrapper>
        {COLORS?.map((color) => (
            <ColorElement
                key={color}
                color={color}
                selected={value === color}
                currentBackground={value}
                onClick={() => onChange?.(color)}/>))}
        <UserColorChoose className={'user-color-choose'}>
            <ChangeBgBtn ref={colorPickerButton} onClick={() => togglePicker(!picker)}/>
            {picker && (
                <ClickAwayListener onClickAway={({ target }) => {
                    if (target !== colorPickerButton.current) {
                        togglePicker(!picker)
                    }
                }}>
                    <UserColorChooseBlock>
                        <SketchPicker
                            color={value}
                            onChangeComplete={(color) => onChange?.(color.hex)}
                            presetColors={COLORS}
                            disableAlpha
                        />
                    </UserColorChooseBlock>
                </ClickAwayListener>
            )}
        </UserColorChoose>
    </ColorPickerWrapper>
}import styled from "styled-components";
import {FC, useRef, useState} from "react";
import {ColorElement} from "../../pages/projectEdit/components/ColorPicker/styles";
import {ChangeBgBtn, UserColorChoose, UserColorChooseBlock} from "../../pages/projectEdit/styles";
import ClickAwayListener from "react-click-away-listener";
import SketchPicker from "react-color/lib/components/sketch/Sketch";
import {LayoutConst} from "../../../core";

const ColorPickerWrapper = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 12px;
    row-gap: 10px;
    width: fit-content !important;

    ${ColorElement} {
        margin: 0;
    }
    ${UserColorChoose} {
        margin: 0;
        height: 36px!important;
        width: 36px!important;

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 26px!important;
            width: 26px!important;
        }
    }

    ${ChangeBgBtn} {
        height: 36px!important;
        width: 36px!important;
        
        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            height: 26px!important;
            width: 26px!important;
        }
    }
    
    input {
        height: inherit !important;
        width: 100% !important;
        font-weight: inherit;
        font-size: 11px !important;
        line-height: inherit;
        color: inherit !important;
        background-color: inherit !important;
    }
`

interface ColorPickerProps {
    onChange?: (color: string) => void
    value: string,
}

const COLORS = [
    '#006FFF', '#C43C2C', '#F6C3A1', '#F5BF57', '#F3EC72', '#A3B51D', '#C1D3C4', '#B0C9E3', '#4E7CD4', '#000', '#ADA7A0', '#E1DDCD', '#D2D4D3',
];


export const ColorPickerVertical:FC<ColorPickerProps> = ({ value, onChange }) => {

    const colorPickerButton = useRef<HTMLDivElement>(null);
    const [picker, togglePicker] = useState(false);

    return <ColorPickerWrapper>
        {COLORS?.map((color) => (
            <ColorElement
                key={color}
                color={color}
                selected={value === color}
                currentBackground={value}
                onClick={() => onChange?.(color)}/>))}
        <UserColorChoose className={'user-color-choose'}>
            <ChangeBgBtn ref={colorPickerButton} onClick={() => togglePicker(!picker)}/>
            {picker && (
                <ClickAwayListener onClickAway={({ target }) => {
                    if (target !== colorPickerButton.current) {
                        togglePicker(!picker)
                    }
                }}>
                    <UserColorChooseBlock>
                        <SketchPicker
                            color={value}
                            onChangeComplete={(color) => onChange?.(color.hex)}
                            presetColors={COLORS}
                            disableAlpha
                        />
                    </UserColorChooseBlock>
                </ClickAwayListener>
            )}
        </UserColorChoose>
    </ColorPickerWrapper>
}